import { render, staticRenderFns } from "./MtArrowLink.vue?vue&type=template&id=778a6096&scoped=true&"
import script from "./MtArrowLink.vue?vue&type=script&lang=js&"
export * from "./MtArrowLink.vue?vue&type=script&lang=js&"
import style0 from "./MtArrowLink.vue?vue&type=style&index=0&id=778a6096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a6096",
  null
  
)

export default component.exports